export const STANDOUT_SELECTION_STORAGE_KEY = 'standout-selected';
